import { generateDiv3x1 } from '../generators/math/div3x1';
import { runGenericMathKpLesson } from './_runner';
import type { LearnDoneCallback } from '../app';

/**
 * KP `math.div.mul-relation` (N-3-6):
 * 三下「乘除關係與應用解題」— uses generateDiv3x1 whose template emphasises
 * recovering the quotient through the inverse-multiplication relation.
 */
export function runMathDivMulRelationLesson(container: HTMLElement, onDone: LearnDoneCallback): void {
  runGenericMathKpLesson(container, {
    subject: 'math',
    kpId: 'math.div.mul-relation',
    generator: generateDiv3x1,
  }, onDone);
}
